import { z } from "zod";
import { perCompanyQuerySchema } from "./perCompanyQuerySchema";

export const unacknowledgedPlatformNotificationsPerCompanyQuerySchema =
  perCompanyQuerySchema.extend({
    limit: z.number().int().min(1).optional(),
  });

export type UnacknowledgedPlatformNotificationsPerCompanyQuery = z.infer<
  typeof unacknowledgedPlatformNotificationsPerCompanyQuerySchema
>;
